/** Tuning for viseme15 lipsync playback and frame interpolation. */
const avatarLipsyncConfig = {
  frameRate: {
    nudgytAgent: 60,
    convai: 100
  },
  viseme15: {
    vowelBoost: {
      viseme_aa: 1.2,
      viseme_E: 1.15,
      viseme_O: 0.6,
      viseme_I: 0.8,
      viseme_U: 0.6
    },
    maxWeight: {
      viseme_O: 0.35,
      viseme_U: 0.35,
      viseme_I: 0.5
    },
    mouthOpenGain: 0.126,
    fullEnergyWeight: 0.6,
    mouthCloseContrast: 1.55,
    minWeight: 0.002,
    smoothAlpha: 0.62,
    applySpeed: 0.88,
    vowelApplySpeed: 0.95,
    decaySpeed: 0.32,
    mouthOpenSmoothAlpha: 0.35,
    mouthOpenApplySpeed: 0.6,
    resetLerpSpeed: 0.35
  }
};

export default avatarLipsyncConfig;
